import React, { useState, useEffect ,useRef} from 'react';
import { Tabs, Tab, Grid, Button, Box, Divider, CircularProgress, Alert, Typography } from '@mui/material';
import TicketDetails from 'Containers/Ticket/TicketDetails';
import { VisibilityOutlined } from "@mui/icons-material";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { getUrlParam } from 'Includes/functions';
function TicketTabs(props) { 
    const navigate = useNavigate();
    const [value, setValue] = useState();
    const [ticketIdState, setTicketIdState] = useState(''); 
    const [is_edit_form, set_is_edit_form] = useState(false);
    const [loading, set_loading] = useState(true);
    const companyId = useParams().companyId; 
    const location = useLocation();
    console.log('location',location);
    const ticketId = getUrlParam().ticket_id;  
    const previousUrlRef = useRef(null);
    const secondLastUrlRef = useRef(null);
    
    
    const handleViewTickets = () => {
        const previousURL = localStorage.getItem("previousURL");
    
        if (previousURL) {
            navigate(previousURL);
            localStorage.removeItem("previousURL"); 
        } else {
            const storedCompanyId = localStorage.getItem("selectedCompanyId") || companyId;
            navigate(`/ticket/list/${storedCompanyId}`);
        }
    };

    useEffect(() => {   
        secondLastUrlRef.current = previousUrlRef.current;
        previousUrlRef.current = location.pathname;
        console.log(location.pathname);

            if (location.pathname.startsWith(`/ticket/list/${companyId}/detail`)) {
            
            if (ticketId) {
                set_is_edit_form(true);
                set_loading(false);
                setTicketIdState(ticketId);
                console.log('ticketId',ticketId);
            } else {
                console.log('else');
                navigate(`/ticket/list/${companyId}`);  
            }
        } else {
            setValue(0);
            set_loading(false);
        }
    }, [companyId]);  

    return (
        <>
            {loading && <CircularProgress />}
            {!loading &&
                <>
                    <Grid container>
                        <Grid item md={6} xs={12} className='header-align'>
                        <Typography sx={{fontSize : '30px'}} fontWeight={700}>
                                            Ticket Details
                                        </Typography>
                        </Grid>
                        <Grid item md={6} xs={12} >
                            <Box className='header-align end-flex-prop'>
                                <Button
                                    variant='contained'
                                    className='editbutton-view'
                                    onClick={handleViewTickets}
                                >
                                    <VisibilityOutlined className='visibility-icon' /> View Tickets
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box mt={3} mb={1}>
                        <Divider />
                    </Box>
                    {ticketIdState &&
                        <TicketDetails ticket_id={ticketIdState} {...props} />
                    }
                </>
            }
        </>
        
    );
}

export default TicketTabs;